export class BaseTool {
    // 获取ip地址
    public static getUserIp(callback) {
        $.get("http://ipinfo.io/ip", function (response) {
            if (response) {
                window.userIP = response;
                callback();
            }
        }, "text")
            .catch(error => {
                console.warn(error);
            })
    }

    // 获取地区code
    public static getCountryCode(callback) {
        $.get("https://ipinfo.io/" + window.userIP, function (response) {
            if (response) {
                callback(response.country);
            } else {
                callback(null);
            }

        }, "jsonp")
            .catch(error => {
                console.warn(error);
            })
    }
}